import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=761d4818&scoped=true&"
import script from "./CourseContent.vue?vue&type=script&lang=js&"
export * from "./CourseContent.vue?vue&type=script&lang=js&"
import style0 from "./CourseContent.vue?vue&type=style&index=0&id=761d4818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d4818",
  null
  
)

export default component.exports